export const PERMISSION_LIST_KEY = "permissions";

// ============================================================================
// Admin Side
// ============================================================================

// Dashboard
export const DASHBOARD_PERMISSION = {
  DASHBOARD_READ: "admin_dashboard_read",
};

// Courses
export const COURSE_CATALOG_PERMISSION = {
  COURSE_CATALOG_READ: "admin_course_catalog_read",
  COURSE_CATALOG_WRITE: "admin_course_catalog_write",
};

// Deleting a course is a separate grant from editing it. The control lives on the
// Edit Course page (metadata modal), not the catalog.
export const COURSE_DELETE_PERMISSION = {
  COURSE_DELETE: "admin_course_delete",
};

export const COURSE_GENERATION_PERMISSION = {
  COURSE_GENERATION_READ: "admin_course_generation_read",
  COURSE_GENERATION_WRITE: "admin_course_generation_write",
};

export const SCORM_IMPORT_PERMISSION = {
  SCORM_IMPORT_READ: "admin_scorm_import_read",
  SCORM_IMPORT_WRITE: "admin_scorm_import_write",
};

export const AVATAR_LIBRARY_PERMISSION = {
  AVATAR_LIBRARY_READ: "admin_avatar_library_read",
  AVATAR_LIBRARY_WRITE: "admin_avatar_library_write",
};

export const CATEGORY_PERMISSION = {
  CATEGORY_READ: "admin_category_read",
  CATEGORY_WRITE: "admin_category_write",
};

export const TRENDING_TOPICS_PERMISSION = {
  TRENDING_TOPICS_READ: "admin_trending_topics_read",
  TRENDING_TOPICS_WRITE: "admin_trending_topics_write",
};

export const COURSE_ASSIGNMENT_PERMISSION = {
  COURSE_ASSIGNMENT_READ: "admin_course_assignment_read",
  COURSE_ASSIGNMENT_WRITE: "admin_course_assignment_write",
};

export const COURSE_ASSIGNMENT_ANALYTICS_PERMISSION = {
  COURSE_ASSIGNMENT_ANALYTICS_READ: "admin_course_assignment_analytics_read",
  COURSE_ASSIGNMENT_ANALYTICS_WRITE: "admin_course_assignment_analytics_write",
};

// Certifications
export const CERTIFICATION_CATALOG_PERMISSION = {
  CERTIFICATION_CATALOG_READ: "admin_certification_catalog_read",
  CERTIFICATION_CATALOG_WRITE: "admin_certification_catalog_write",
};

// Separate grant from editing; the control lives in the certification's edit modal.
export const CERTIFICATION_DELETE_PERMISSION = {
  CERTIFICATION_DELETE: "admin_certification_delete",
};

export const CERTIFICATION_CREATION_PERMISSION = {
  CERTIFICATION_CREATION_READ: "admin_certification_creation_read",
  CERTIFICATION_CREATION_WRITE: "admin_certification_creation_write",
};

export const CERTIFICATION_ASSIGNMENT_PERMISSION = {
  CERTIFICATION_ASSIGNMENT_READ: "admin_certification_assignment_read",
  CERTIFICATION_ASSIGNMENT_WRITE: "admin_certification_assignment_write",
};

export const CERTIFICATION_ASSIGNMENT_ANALYTICS_PERMISSION = {
  CERTIFICATION_ASSIGNMENT_ANALYTICS_READ: "admin_certification_assignment_analytics_read",
  CERTIFICATION_ASSIGNMENT_ANALYTICS_WRITE: "admin_certification_assignment_analytics_write",
};

// Learning Paths
export const LEARNING_PATH_CATALOG_PERMISSION = {
  ADMIN_LEARNING_PATH_CATALOG_READ: "admin_learning_path_catalog_read",
  ADMIN_LEARNING_PATH_CATALOG_WRITE: "admin_learning_path_catalog_write",
};

// Separate grant from editing; the control lives in the learning path's edit modal.
export const LEARNING_PATH_DELETE_PERMISSION = {
  ADMIN_LEARNING_PATH_DELETE: "admin_learning_path_delete",
};

export const LEARNING_PATH_CREATION_PERMISSION = {
  ADMIN_LEARNING_PATH_CREATION_READ: "admin_learning_path_creation_read",
  ADMIN_LEARNING_PATH_CREATION_WRITE: "admin_learning_path_creation_write",
};

export const LEARNING_PATH_WORKFLOW_PERMISSION = {
  ADMIN_LEARNING_PATH_WORKFLOW_READ: "admin_learning_path_workflow_read",
  ADMIN_LEARNING_PATH_WORKFLOW_WRITE: "admin_learning_path_workflow_write",
};

export const LEARNING_PATH_ASSIGNMENT_PERMISSION = {
  ADMIN_LEARNING_PATH_ASSIGNMENT_READ: "admin_learning_path_assignment_read",
  ADMIN_LEARNING_PATH_ASSIGNMENT_WRITE: "admin_learning_path_assignment_write",
};

export const LEARNING_PATH_ASSIGNMENT_ANALYTICS_PERMISSION = {
  ADMIN_LEARNING_PATH_ASSIGNMENT_ANALYTICS_READ: "admin_learning_path_assignment_analytics_read",
  ADMIN_LEARNING_PATH_ASSIGNMENT_ANALYTICS_WRITE: "admin_learning_path_assignment_analytics_write",
};

// User Management
export const USERS_PERMISSION = {
  ADMIN_USERS_READ: "admin_users_read",
  ADMIN_USERS_WRITE: "admin_users_write",
};

export const INVITE_MANAGEMENT_PERMISSION = {
  ADMIN_INVITE_MANAGEMENT_READ: "admin_invite_management_read",
  ADMIN_INVITE_MANAGEMENT_WRITE: "admin_invite_management_write",
};

export const GROUPS_PERMISSION = {
  ADMIN_GROUPS_READ: "admin_groups_read",
  ADMIN_GROUPS_WRITE: "admin_groups_write",
};

export const ROLES_PERMISSION = {
  ADMIN_ROLES_READ: "admin_roles_read",
  ADMIN_ROLES_WRITE: "admin_roles_write",
};

// Analytics & Performance
export const ANALYTICS_OVERVIEW_PERMISSION = {
  ADMIN_COURSE_ANALYTICS_READ: "admin_course_analytics_read",
  ADMIN_CERTIFICATION_ANALYTICS_READ: "admin_certification_analytics_read",
};

export const EMPLOYEE_PROGRESS_PERMISSION = {
  ADMIN_EMPLOYEE_PROGRESS_READ: "admin_employee_progress_read",
  ADMIN_EMPLOYEE_PROGRESS_WRITE: "admin_employee_progress_write",
};

export const MY_TEAM_PROGRESS_PERMISSION = {
  ADMIN_MY_TEAM_PROGRESS_READ: "admin_my_team_progress_read",
  ADMIN_MY_TEAM_PROGRESS_WRITE: "admin_my_team_progress_write",
};

export const DEPARTMENT_PROGRESS_PERMISSION = {
  ADMIN_DEPARTMENT_PROGRESS_READ: "admin_department_progress_read",
  ADMIN_DEPARTMENT_PROGRESS_WRITE: "admin_department_progress_write",
};

export const ROLE_PROGRESS_PERMISSION = {
  ADMIN_ROLE_PROGRESS_READ: "admin_role_progress_read",
  ADMIN_ROLE_PROGRESS_WRITE: "admin_role_progress_write",
};

export const COURSE_PERFORMANCE_PERMISSION = {
  ADMIN_COURSE_PERFORMANCE_READ: "admin_course_performance_read",
  ADMIN_COURSE_PERFORMANCE_WRITE: "admin_course_performance_write",
};

export const LEARNING_PATH_PERFORMANCE_PERMISSION = {
  ADMIN_LEARNING_PATH_PERFORMANCE_READ: "admin_learning_path_performance_read",
  ADMIN_LEARNING_PATH_PERFORMANCE_WRITE: "admin_learning_path_performance_write",
};

export const CERTIFICATION_PERFORMANCE_PERMISSION = {
  ADMIN_CERTIFICATION_PERFORMANCE_READ: "admin_certification_performance_read",
  ADMIN_CERTIFICATION_PERFORMANCE_WRITE: "admin_certification_performance_write",
};

export const ACTIVITY_REPORT_PERMISSION = {
  ADMIN_ACTIVITY_REPORT_READ: "admin_activity_report_read",
  ADMIN_ACTIVITY_REPORT_WRITE: "admin_activity_report_write",
};

// Gamification
export const LEADERBOARD_PERMISSION = {
  ADMIN_LEADERBOARD_READ: "admin_leaderboard_read",
};

export const BADGE_MANAGEMENT_PERMISSION = {
  ADMIN_BADGE_MANAGEMENT_READ: "admin_badge_management_read",
  ADMIN_BADGE_MANAGEMENT_WRITE: "admin_badge_management_write",
};

export const USER_ACHIEVEMENTS_PERMISSION = {
  ADMIN_USER_ACHIEVEMENTS_READ: "admin_user_achievements_read",
};

// Reviews
export const REVIEWS_PERMISSION = {
  ADMIN_REVIEWS_MANAGEMENT_READ: "admin_reviews_management_read",
  ADMIN_REVIEWS_MANAGEMENT_WRITE: "admin_reviews_management_write",
};

// Knowledge / Documents
export const DOCUMENT_STORE_PERMISSION = {
  ADMIN_DOCUMENT_STORE_READ: "admin_document_store_read",
  ADMIN_DOCUMENT_STORE_WRITE: "admin_document_store_write",
};

// Settings
export const BUSINESS_SETTINGS_PERMISSION = {
  ADMIN_BUSINESS_SETTINGS_READ: "admin_business_settings_read",
  ADMIN_BUSINESS_SETTINGS_WRITE: "admin_business_settings_write",
};

export const TICKET_REQUESTS_PERMISSION = {
  ADMIN_TICKET_REQUESTS_READ: "admin_ticket_requests_read",
  ADMIN_TICKET_REQUESTS_WRITE: "admin_ticket_requests_write",
};

export const WEBHOOK_SETTINGS_PERMISSION = {
  ADMIN_WEBHOOK_SETTINGS_READ: "admin_webhook_settings_read",
  ADMIN_WEBHOOK_SETTINGS_WRITE: "admin_webhook_settings_write",
};

export const AI_MODEL_SETTINGS_PERMISSION = {
  ADMIN_AI_MODEL_SETTINGS_READ: "admin_ai_model_settings_read",
  ADMIN_AI_MODEL_SETTINGS_WRITE: "admin_ai_model_settings_write",
};

// Enterprise
export const SSO_CONFIGURATION_PERMISSION = {
  ADMIN_SSO_CONFIGURATION_READ: "admin_sso_configuration_read",
  ADMIN_SSO_CONFIGURATION_WRITE: "admin_sso_configuration_write",
};

export const SCIM_CONFIGURATION_PERMISSION = {
  ADMIN_SCIM_CONFIGURATION_READ: "admin_scim_configuration_read",
  ADMIN_SCIM_CONFIGURATION_WRITE: "admin_scim_configuration_write",
};

export const LTI_INTEGRATION_PERMISSION = {
  ADMIN_LTI_INTEGRATION_READ: "admin_lti_integration_read",
  ADMIN_LTI_INTEGRATION_WRITE: "admin_lti_integration_write",
};

// Email Logs
export const EMAIL_LOGS_PERMISSION = {
  ADMIN_EMAIL_LOGS_READ: "admin_email_logs_read",
};

// Templates
export const EMAIL_TEMPLATE_PERMISSION = {
  ADMIN_EMAIL_TEMPLATE_READ: "admin_email_template_read",
  ADMIN_EMAIL_TEMPLATE_WRITE: "admin_email_template_write",
};

export const CERTIFICATE_TEMPLATE_PERMISSION = {
  ADMIN_CERTIFICATE_TEMPLATE_READ: "admin_certificate_template_read",
  ADMIN_CERTIFICATE_TEMPLATE_WRITE: "admin_certificate_template_write",
};

// Training Status Report (previously Overdue Learner Report)
export const TRAINING_STATUS_REPORT_PERMISSION = {
  ADMIN_TRAINING_STATUS_REPORT_READ: "admin_training_status_report_read",
  ADMIN_TRAINING_STATUS_REPORT_WRITE: "admin_training_status_report_write",
};

// AI Cost Tracking (cross-tenant AI usage & cost dashboard)
export const AI_COST_TRACKING_PERMISSION = {
  ADMIN_AI_COST_TRACKING_READ: "admin_ai_cost_tracking_read",
  ADMIN_AI_COST_TRACKING_WRITE: "admin_ai_cost_tracking_write",
};

export const AI_USAGE_PERMISSION = {
  ADMIN_AI_USAGE_READ: "admin_ai_usage_read",
  ADMIN_AI_USAGE_WRITE: "admin_ai_usage_write",
};

// Audit Trail
export const AUDIT_TRAIL_PERMISSION = {
  ADMIN_AUDIT_TRAIL_READ: "admin_audit_trail_read",
  ADMIN_AUDIT_TRAIL_WRITE: "admin_audit_trail_write",
};

// ============================================================================
// Learner Side
// ============================================================================

export const LEARNER_DASHBOARD_PERMISSION = {
  LEARNER_DASHBOARD_READ: "learner_dashboard_read",
};

export const LEARNER_COURSES_PERMISSION = {
  LEARNER_COURSES_READ: "learner_courses_read",
  LEARNER_COURSES_WRITE: "learner_courses_write",
};

export const LEARNER_LEARNING_PATHS_PERMISSION = {
  LEARNER_LEARNING_PATHS_READ: "learner_learning_paths_read",
  LEARNER_LEARNING_PATHS_WRITE: "learner_learning_paths_write",
};

export const LEARNER_CERTIFICATIONS_PERMISSION = {
  LEARNER_CERTIFICATIONS_READ: "learner_certifications_read",
  LEARNER_CERTIFICATIONS_WRITE: "learner_certifications_write",
};

export const LEARNER_SCHEDULE_PERMISSION = {
  LEARNER_SCHEDULE_READ: "learner_schedule_read",
};

export const LEARNER_TICKETS_PERMISSION = {
  LEARNER_TICKETS_READ: "learner_tickets_read",
  LEARNER_TICKETS_WRITE: "learner_tickets_write",
};

export const LEARNER_LEADERBOARD_PERMISSION = {
  LEARNER_LEADERBOARD_READ: "learner_leaderboard_read",
};

export const LEARNER_GAMIFICATION_PERMISSION = {
  LEARNER_GAMIFICATION_READ: "learner_gamification_read",
  LEARNER_GAMIFICATION_WRITE: "learner_gamification_write",
};

export const LEARNER_CONTACT_SUPPORT_PERMISSION = {
  LEARNER_CONTACT_SUPPORT_READ: "learner_contact_support_read",
  LEARNER_CONTACT_SUPPORT_WRITE: "learner_contact_support_write",
};
